import { gql, useQuery } from '@apollo/client'

type LoyaltyLevel = {
  name: string
  description?: string
  threshold: number
  preference?: string
  preferencePostfix?: string
  needToNextLevel?: number
  nextCalcDate?: string
}

type CustomLoyaltyLevelInfo = {
  id: string
  name: string
  currentValue: number
  levels: LoyaltyLevel[]
  currentLevel?: LoyaltyLevel
  nextLevel?: LoyaltyLevel
  returnAmount?: number
  saleAmount?: number
}

type GetCustomLoyaltyLevelInfoResponse = {
  getCustomLoyaltyLevelInfo?: CustomLoyaltyLevelInfo
}

type GetCustomLoyaltyLevelInfoVariables = {
  code: string
}

const GQL_QUERY_GET_CUSTOM_LOYALTY_LEVEL_INFO = gql`
  query getCustomLoyaltyLevelInfo($code: String!) {
    getCustomLoyaltyLevelInfo(code: $code) {
      id
      name
      currentValue
      levels {
        name
        description
        threshold
        preference
        preferencePostfix
      }
      currentLevel {
        name
        description
        threshold
        preference
        preferencePostfix
      }
      nextLevel {
        name
        description
        threshold
        preference
        preferencePostfix
        needToNextLevel
        nextCalcDate
      }
      returnAmount
      saleAmount
    }
  }
`

type UseFetchCustomLoyaltyLevelInfoParams = {
  code: string
  skip?: boolean
}

export function useFetchCustomLoyaltyLevelInfo ({
  code,
  skip = false
}: UseFetchCustomLoyaltyLevelInfoParams) {
  const { data, loading, error, refetch } = useQuery<
    GetCustomLoyaltyLevelInfoResponse,
    GetCustomLoyaltyLevelInfoVariables
  >(GQL_QUERY_GET_CUSTOM_LOYALTY_LEVEL_INFO, {
    variables: { code },
    skip,
    fetchPolicy: 'cache-and-network'
  })

  return {
    data: data?.getCustomLoyaltyLevelInfo,
    loading,
    error,
    refetch
  }
}
